export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5232.07bbf808.jpg";